export enum ActionType {
    SET_LOGIN_POPUP = 'SET_LOGIN_POPUP',
    SET_USERDATA = 'SET_USERDATA'
}

export type Action = {
    type: ActionType,
    payload: any
}